<div class="dialog-header">
  <h2>Crear Empresa Nueva</h2>
</div>

<div class="dialog-content">
  <div class="form-group">
    <label>CUIT:</label>
    <input type="text" class="form-control" [(ngModel)]="cuit" placeholder="Ej: 30-12345678-9" maxlength="13">
    <small class="form-text text-muted">11 dígitos con o sin guiones</small>
  </div>

  <div class="form-group">
    <label>Razón Social <span style="color: red;">*</span></label>
    <input type="text" class="form-control" [(ngModel)]="razonSocial" placeholder="Nombre de la empresa">
  </div>

  <div class="form-group">
    <label>Contacto:</label>
    <input type="text" class="form-control" [(ngModel)]="contacto" placeholder="Nombre o teléfono de contacto">
  </div>

  <div class="form-group">
    <label>Calle:</label>
    <input type="text" class="form-control" [(ngModel)]="calle" placeholder="Dirección">
  </div>

  <div class="form-group">
    <label>Puerta:</label>
    <input type="text" class="form-control" [(ngModel)]="puerta" placeholder="Número o referencia">
  </div>

  <div class="form-group">
    <label>Código Postal:</label>
    <input type="text" class="form-control" [(ngModel)]="codigoPostal" placeholder="CP">
  </div>
</div>

<div class="dialog-actions">
  <button class="btn btn-secondary" (click)="cancelar()">Cancelar</button>
  <button class="btn btn-primary" (click)="crearEmpresa()" [disabled]="!razonSocial || guardando">
    <span *ngIf="!guardando"><i class="fa fa-plus"></i> Crear</span>
    <span *ngIf="guardando"><i class="fa fa-spinner fa-spin"></i> Creando...</span>
  </button>
</div>
